import { motion } from "framer-motion";
import { EASE_IO } from "./motion";
import { Symbol } from "./Logo";

export const Curtain = ({ label }) => (
  <motion.div
    data-testid="page-curtain"
    className="pointer-events-none fixed inset-0 z-[100] flex items-center justify-center bg-skaris-navy"
    initial={{ y: "0%" }}
    animate={{ y: "-100%" }}
    transition={{ duration: 0.9, ease: EASE_IO, delay: 0.45 }}
  >
    <div className="flex flex-col items-center gap-5">
      <motion.div initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ duration: 0.45, ease: EASE_IO }}>
        <Symbol className="h-14 w-auto text-cream" />
      </motion.div>
      <span className="font-mono text-[11px] uppercase tracking-[0.4em] text-cream/70">{label}</span>
    </div>
  </motion.div>
);
